// extracted by mini-css-extract-plugin
module.exports = {"blogArticle":"post-module--blogArticle--1Ro02","title":"post-module--title--SmQUo","postEmoji":"post-module--postEmoji--Suiy_"};